import * as React from "react";
const SvgBuyersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 149 149"
    {...props}
  >
    <circle cx={74.5} cy={74.5} r={72.5} stroke="#FFA100" strokeWidth={4} />
    <path
      fill="#FFA100"
      d="M56.06 40.965C56.06 34.357 61.387 29 67.955 29c6.568 0 11.893 5.357 11.893 11.965 0 6.609-5.325 11.966-11.893 11.966-6.569 0-11.893-5.357-11.893-11.966Zm54.632 63.961-8.387.007v4.216h-2.796v-4.216h-13.98v4.216h-2.795v-4.216h-8.388v14.057h36.346v-14.064Zm-26.283-14.05V73.862c0-.905.578-1.52 1.51-1.52.9 0 1.511.582 1.511 1.52v19.812H74.346v8.445l36.346-.006v-8.44H97.908v-22.85c0-8.31-6.75-15.068-14.978-15.068h-3.02L70.75 69.53 69.35 58.719l1.398-2.996h-5.59l1.397 2.996-1.398 10.81-8.646-13.774h-3.535c-8.26 0-14.977 6.79-14.977 15.068v40.263c0 2.911 2.345 5.27 5.239 5.27 2.893 0 5.239-2.359 5.239-5.27V73.862h-.033c0-.912.587-1.528 1.531-1.52.828.009 1.49.704 1.49 1.537l-.005 45.111 20.09.01V90.876h12.858Z"
    />
  </svg>
);
export default SvgBuyersIcon;
